//import DesignDistributor from 'emun.on-demand/admin/design-distributor'
//import DesignDistributorWizard from 'emun.on-demand/admin/design-distributor-wizard'
//import DesignDistributorHeader from 'emun.on-demand/admin/design-distributor-header'
//import DesignImporter from 'emun.on-demand/admin/design-importer'
import DesignPublishingGroup from 'emun.on-demand/admin/design-publishing-group'
import DesignPublisher from 'emun.on-demand/admin/design-publisher'
import ProductManager from 'emun.on-demand/admin/od-product-manager'
import ProductManagerDependent from 'emun.on-demand/admin/od-product-manager-dependent'
import ProductProducer from 'emun.on-demand/admin/od-product-producer'
//import ProductManagerActions from 'emun.on-demand/admin/od-product-manager-actions'

const dependencies = [
    'views',
    'emun.auth',
    'webcolors',
    'webfonts',
    'emun.cart',
    'emun.shopping',
    'ngFileUpload',
    'ui.router'];

function Routes($stateProvider, $urlRouterProvider, $locationProvider) {
}
function register(mod) {
    return mod.component('designPublisher', DesignPublisher)
        .component('designPublishingGroup', DesignPublishingGroup)
        .component('odProductProducer', ProductProducer)
        .component('odProductManager', ProductManager)
        .component('odProductManagerDependent', ProductManagerDependent)
        //.component('odDesignManager', DesignManager)
        //.component('odDesignManagerDependent', DesignManagerDependent)
        //.component('odDesignFieldset', DesignFieldset);
        .config(Routes)
        .name;
}

export default register;